<template>
  <div>
    <Dialog
      :key="mainDialogKey"
      :visible.sync="enquirySelectionDialog1"
      :style="{ width: '800px', height: '600px', overflowY: 'auto' }"
      :modal="true"
      :closable="true"
      :closeOnEscape="true"
      header="Enquiry Selection"
      class="p-fluid"
      :maximizable="true"
    >
      <template>
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText
            v-model="filters['global']"
            placeholder="Global Search"
            style="margin-right: 0.5em"
            @input="updateSearch"
          />
        </span>
      </template>

      <br />
      <div v-if="requestingEnquiries" style="width: 100%; text-align: center;">
        <ProgressSpinner
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
      </div>
      <DataTable
        :value="enquiries3"
        :filters="filters"
        :selection.sync="selectedEnquiry"
        @row-select="onRowSelect"
        dataKey="oppId"
        class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers p-my-4"
        :scrollable="true"
        scrollHeight="200px"
        :loading="loading"
        :lazy="true"
        :rows="20"
        :virtualScroll="true"
        :virtualRowHeight="45"
        @virtual-scroll="onVirtualScroll"
        :totalRecords="lazyTotalRecords"
        selectionMode="single"
      >
        <template #header>
          Enquiries
        </template>

        <Column
          field="sQuoteNo"
          header="Quote No"
          :sortable="true"
          headerStyle="width: 5em; text-align: center"
        >
          <template #loading>
            <span class="loading-text"></span>
          </template>
        </Column>
        <Column
          field="dateCreated"
          header="Quote Date"
          :sortable="true"
          headerStyle="width: 10em; text-align: center"
        >
          <template #loading>
            <span class="loading-text">loading</span>
          </template>
        </Column>
        <Column
          field="customer.custName"
          header="Customer Name"
          :sortable="true"
          headerStyle="width: 17em; text-align: center"
        >
          <template #loading>
            <span class="loading-text">loading</span>
          </template>
          <template #body="slotProps">
            {{ slotProps.data.customerName }}
          </template>
        </Column>
        <Column
          field="oppDescription"
          header="Description"
          :sortable="true"
          headerStyle="width: 20em; text-align: center"
        >
          <template #loading>
            <span class="loading-text"></span>
          </template>
        </Column>
        <Column
          field="mbpBranch"
          header="Branch"
          :sortable="true"
          headerStyle="width: 7em; text-align: center"
        >
          <template #loading>
            <span class="loading-text"></span>
          </template>
        </Column>
        <Column
          field="quoteValue"
          header="Value"
          :sortable="true"
          headerStyle="width: 7em; text-align: center"
        >
          <template #loading>
            <span class="loading-text">loading</span>
          </template>
          <template #body="slotProps">
            {{ showCurrency(slotProps.data.quoteValue) }}
          </template>
        </Column>
        <Column
          field="opportunityStatus"
          header="Status"
          :sortable="true"
          headerStyle="width: 5em; text-align: center"
        >
          <template #loading>
            <span class="loading-text">loading</span>
          </template>
          <template #body="slotProps">
            <span
              :class="'badge ' + getStyle1(slotProps.data.opportunityStatus)"
              style="font-size: 16px;"
            >
              {{ slotProps.data.opportunityStatus }}
            </span>
          </template>
        </Column>
      </DataTable>

      <template #footer>
        <Button
          class="p-button-success p-mr-2"
          label="Select"
          @click="select"
          style="width: auto"
        />
        <Button
          class="p-button-secondary p-mr-2"
          label="Cancel"
          @click="$emit('close')"
          style="width: auto"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import OpportunityService from "@/service/OpportunityService";

export default {
  name: "EnquirySelection",
  props: {
    enquirySelectionDialog: {
      type: Boolean,
      requrired: false
    },
    enquiries: {
      type: Array,
      required: false
    },
    requestingEnquiries: {
      type: Boolean,
      requrired: false
    }
  },
  data: () => ({
    opportunityService: new OpportunityService(),
    lazyTotalRecords: 0,
    enquiries1: [],
    enquiries2: null,
    enquiries3: [],
    selectedEnquiry: {},
    filters: {},
    mainDialogKey: 0,
    requesting: false
  }),
  computed: {
    loading() {
      //
      if (this.enquiries2 && this.enquiries2[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    },
    enquirySelectionDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        if (this.enquirySelectionDialog) {
          this.setupEnquiries(); // its like reloading this component
          return true;
        } else {
          return false;
        }
      }
    }
  },
  created() {
    this.setupEnquiries();
  },
  watch: {
    enquiries2(val) {
      if (val && val[0]) {
        this.enquiries3 = this.loadChunk(0, 40);
        this.lazyTotalRecords = val.length;
      }
    }
  },
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getStyle1(status) {
      // For quotation
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (status) {
        if (status.toLowerCase() === "lost") {
          return "badge-danger";
        } else if (status.toLowerCase() === "active") {
          return "badge-primary";
        } else if (status.toLowerCase() === "won") {
          return "badge-success";
        } else if (status.toLowerCase() === "cancelled") {
          return "badge-warning";
        } else if (status.toLowerCase() === "revised") {
          return "badge-info";
        } else if (status.toLowerCase() === "closed") {
          return "badge-secondary";
        } else {
          return "badge-dark";
        }
      } else {
        return "badge-dark";
      }
    },
    showCurrency(quoteValue) {
      if (quoteValue) {
        let c = quoteValue.toString().split(".");
        //

        if (c[0]) {
          let d = c[0].split(",");
          if (d.length < 2) {
            c[0] = this.numberWithCommas(c[0]);
          }
        }
        //

        if (c[1]) {
          if (c[1].length === 1) {
            c[1] = `${c[1]}0`;
          } else {
            c[1] = c[1].substring(0, 2);
          }
          //
          return `£${c[0]}.${c[1]}`;
        } else {
          return `£${c[0]}.00`;
        }
      } else {
        return "";
      }
    },
    setupEnquiries() {
      if (this.enquiries && this.enquiries[0]) {
        this.enquiries1 = this.enquiries;
        this.enquiries2 = this.enquiries;
      } else {
        // getAllActiveOpportunities endpoint disabled - initialize with empty data
        this.enquiries1 = [];
        this.enquiries2 = [];
        console.warn(
          "EnquirySelectionDialog: getAllActiveOpportunities endpoint is disabled. Component requires enquiries to be passed via props."
        );
      }
      this.mainDialogKey++;
    },
    getStyle(data) {
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data && data.quoteStatus && data.quoteStatus.colourCode) {
        return data.colourCode;
      } else if (
        data &&
        data.quoteStatus &&
        data.quoteStatus.statusName &&
        data.quoteStatus.statusName.toLowerCase() === "lost"
      ) {
        return "badge-danger";
      } else if (
        data &&
        data.quoteStatus &&
        data.quoteStatus.statusName &&
        data.quoteStatus.statusName.toLowerCase() === "active"
      ) {
        return "badge-primary";
      } else if (
        data &&
        data.quoteStatus &&
        data.quoteStatus.statusName &&
        data.quoteStatus.statusName.toLowerCase() === "won"
      ) {
        return "badge-success";
      } else if (
        data &&
        data.quoteStatus &&
        data.quoteStatus.statusName &&
        data.quoteStatus.statusName.toLowerCase() === "cancelled"
      ) {
        return "badge-warning";
      } else if (
        data &&
        data.quoteStatus &&
        data.quoteStatus.statusName &&
        data.quoteStatus.statusName.toLowerCase() === "revised"
      ) {
        return "badge-info";
      } else if (
        data &&
        data.quoteStatus &&
        data.quoteStatus.statusName &&
        data.quoteStatus.statusName.toLowerCase() === "closed"
      ) {
        return "badge-secondary";
      } else {
        return "badge-dark";
      }
    },
    loadChunk(index, length) {
      let chunk = [];
      if (this.enquiries2 && this.enquiries2.length > 0) {
        for (let i = 0; i < length; i++) {
          if (index + i < this.enquiries2.length) {
            chunk[i] = this.enquiries2[index + i];
          }
        }
      }
      return chunk;
    },
    // getAllActiveOpportunities() {
    //   this.requesting = true;
    //   this.opportunityService
    //     .getAllActiveOpportunities()
    //     .then(data => {
    //       this.requesting = false;

    //       this.enquiries1 = data;
    //       this.enquiries2 = data;
    //     })
    //     .catch(e => {
    //       this.requesting = false;

    //       this.$store.dispatch("addErrorMessage", {
    //         severity: "error",
    //         content: 'Some data was not loaded from "activeOpportunities"'
    //       });
    //     });
    // },
    updateSearch(e) {
      if (!e) {
        this.enquiries2 = this.enquiries1;
      } else {
        var a = [];
        this.enquiries1.forEach(opportunity => {
          let b = Object.keys(opportunity);
          for (let i = 0; i < b.length; i++) {
            if (
              opportunity[b[i]] &&
              typeof opportunity[b[i]] === "string" &&
              opportunity[b[i]].search(e) >= 0
            ) {
              a.push(opportunity);
              break;
            }
          }
        });
        //
        this.enquiries2 = a;
      }
    },
    onRowSelect(event) {
      this.selectedEnquiry = event.data;
    },
    onVirtualScroll(event) {
      setTimeout(() => {
        //last chunk
        if (event.first === this.lazyTotalRecords - 40)
          this.enquiries3 = this.loadChunk(event.first, 40);
        else this.enquiries3 = this.loadChunk(event.first, event.rows);
      }, 250);
    },
    select() {
      if (this.selectedEnquiry) this.$emit("selected", this.selectedEnquiry);
    }
  }
};
</script>

<style scoped>
.pointer {
  font-size: 15px;
}
</style>
